export default "__VITE_ASSET__RAtShY_g__"